module.exports = __webpack_public_path__ + "static/img/icon_video_playing.df82b0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/icon_video_playing.png
// module id = 584
// module chunks = 4 5